// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__2Q3nh","inputWrap":"CustomTip_inputWrap__1gAyc"};